// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"360":"2e5eb835","389":"513024f3","471":"920ab382","481":"cf82ceab","553":"0f5164e3","572":"ed20e34a","635":"2ec42609","659":"c7049cad","779":"0a822758","822":"5d4d2626","825":"88facf78","826":"bebfb268","832":"e83bd9b5"}[chunkId] + ".js";
};